import { shopIDsI } from "./Interface";

export const DataToSend = (props: any) => {
    return {
        target: {
            marketplace: props?.redux?.current?.target?.marketplace,
            shopId: props?.redux?.current?.target?.['_id'],
        },
        source: {
            marketplace: props?.redux?.current?.source?.marketplace,
            shopId: props?.redux?.current?.source?.['_id'],
        },
    }
};

/**
 * Function to get smaller size version of image
 * @param url
 * @returns url
 */

export function modifyImageUrl(url: string) {
    // Check if the URL already has size parameters
    if (!url) return url;

    if (url.includes("cdn.shopify.com")) {
        const baseUrl = url.split('?')[0];  // Remove any existing query parameters
        const extensionIndex = baseUrl.lastIndexOf('.');
        const baseName = baseUrl.substring(0, extensionIndex);
        const extension = baseUrl.substring(extensionIndex);
        // Add the 40x40 size modification before the extension
        return `${baseName}_40x40@3x${extension}`;

    } else {
        return url
    }


}
/**
 * Function to get the source and target Shop ID
 * @param props
 * @returns
 */
export const getShopID = (props: any) => {
    return {
        sourceShopID: props.redux.current.source._id,
        targetShopID: props.redux.current.target._id,
    };
};

/**
 * returns the type of status
 */
export const getAllStatus: { [name: string]: { label: string, value: string } } = {
    "Listed": {
        "label": "Listed",
        "value": "Listed",
    },
    "Partial Listed": {
        "label": "Partial Listed",
        "value": "Partial Listed",
    },
    "Active": {
        "label": "Active",
        "value": "Active",
    },
    "Not Listed: Offer": {
        "label": "Not Listed: Offer",
        "value": "Not Listed: Offer",
    },
    "Not Listed": {
        "label": "Not Listed",
        "value": "Not Listed",
    },
    "Inactive": {
        "label": "Inactive",
        "value": "Active",
    },
    "Incomplete": {
        "label": "Incomplete",
        "value": "Active",
    },
    "Uploaded": {
        "label": "Uploaded",
        "value": "Uploaded",
    },
    "Partial Uploaded": {
        "label": "Partial Uploaded",
        "value": "Partial Uploaded",
    },
    "Ready To Upload": {
        "label": "Ready To Upload",
        "value": "Ready To Upload",
    }
}

const getHigherStatus = (parentStatus: string, childStatus: string) => {
    let priorityStatus: any = {
        "Not Listed: Offer": 0,
        "Not Listed": 1,
        "Active": 2,
    }
    let status = "";

    if (parentStatus == "") {
        return childStatus;
    } else {
        status = priorityStatus[getAllStatus[childStatus]?.value] > priorityStatus[getAllStatus[parentStatus]?.value] ? childStatus : parentStatus;
    }
    return status;
}

const simpleTypeProductStatus = (marketPlaceDetails: any[], shopIDs: shopIDsI) => {
    let status = 'Not Listed';

    marketPlaceDetails.forEach((ele) => {
        if (Object.keys(ele).includes("status")) {
            status = ele?.status
        }
    })
    return status
}

const getMergedInfo = (marketPlaceDetails: any[]) => {
    let merged: { [name: string]: any[] } = {};
    marketPlaceDetails.forEach((ele: any) => {
        let source_product_id = ele.source_product_id;
        !merged?.[source_product_id] && (merged[source_product_id] = [])
        merged[source_product_id].push(ele);
    })
    return merged;
}

const variantTypeProductStatus = (marketPlaceDetails: any[], shopIDs: shopIDsI, product: any) => {
    let parentStatus = "";

    const mergedInfo = getMergedInfo(marketPlaceDetails);
    let someNotListed = false; let someOfferListed = false;
    let errorStatus = false
    Object.keys(mergedInfo).forEach((ele) => {

        if (ele == product.source_product_id &&
            Object.keys(mergedInfo[ele][0]).includes("status")
        ) {
            parentStatus = mergedInfo[ele][0]?.status;
            Object.keys(mergedInfo?.[ele]?.[0]).includes("error") && (errorStatus = true)

        }

        if (ele !== product.source_product_id) {
            let info = mergedInfo[ele];
            let childStatus = simpleTypeProductStatus(info, shopIDs);

            childStatus == 'Not Listed' && (someNotListed = true);
            childStatus == "Not Listed: Offer" && (someOfferListed = true);
            childStatus == "Error" && (errorStatus = true);
            parentStatus = getHigherStatus(parentStatus, childStatus);
        }
    })

    let parentActualVal = getAllStatus[parentStatus]?.value;


    someOfferListed && !someNotListed && parentActualVal == 'Active' && (parentStatus = 'Some Variants Listed And Some Not Listed: Offer');
    someOfferListed && someNotListed && parentActualVal == 'Not Listed' && (parentStatus = 'Not Listed: Offer');
    // someNotListed && parentActualVal == 'Active' && (parentStatus = 'Some Variants Listed');
    errorStatus && (parentStatus = 'Error')
    return parentStatus;
}

export const getStatusFormatted = (product: any, shopIDs: shopIDsI) => {
    let marketPlaceDetails: any[] = product?.items ?? [];
    marketPlaceDetails = Object.values(marketPlaceDetails);
    let status = 'Not Listed';
    if (marketPlaceDetails[0] != null) {

        if (product.type == 'simple') {
            status = simpleTypeProductStatus(marketPlaceDetails, shopIDs);
        }
        else {
            status = variantTypeProductStatus(marketPlaceDetails, shopIDs, product);
        }
    }
    return getAllStatus?.[status];
}

export const newFormattedStatus = (product: any, shopIDs: shopIDsI) => {
    let temp: any = [];
    let parent_status: string = 'Not Listed';
    let marketPlaceDetails: any[] = product?.items ?? [];
    let not_listed: boolean = false;
    let listed: boolean = false;
    let uploaded: boolean = false;
    let parentProductStatus: string = "";
    let listed_variant_count: number = 0;
    let Not_listed_variant_count: number = 0;

    marketPlaceDetails = Object.values(marketPlaceDetails);

    if (product?.type == 'simple') {
        parent_status = simpleTypeProductStatus(marketPlaceDetails, shopIDs)
    }
    else {
        product?.items.forEach((ele: any) => {
            if (ele.source_product_id != product.source_product_id) {
                if (ele.status) {
                    temp.push(ele.status)
                }
                else {
                    not_listed = true;
                    temp.push("Not Listed");
                }
            }
            else {
                if (ele?.status) {
                    parentProductStatus = ele?.status;
                }
                else parentProductStatus = "";
            }
        })
        temp.forEach((val: any) => {
            if (val == 'Not Listed' || val == "Not Listed: Offer") {
                not_listed = true
                Not_listed_variant_count += 1;
            }
            else if (val == 'Active' || val == "Inactive" || val == "Incomplete") {
                listed = true
                listed_variant_count += 1;
            }
            else if (val == 'Uploaded') {
                uploaded = true;
            }
        })
    }



    listed && !not_listed && (parent_status = "Listed");
    !listed && not_listed && (parent_status = "Not Listed");
    !listed && not_listed && (parent_status = "Not Listed");
    listed && not_listed && (parent_status = "Partial Listed");
    !listed && not_listed && parentProductStatus == "Ready To Upload" && (parent_status = "Ready To Upload");

    uploaded && !not_listed && !listed && (parent_status = 'Uploaded');
    listed && uploaded && !not_listed && (parent_status = 'Partial Listed');
    !listed && uploaded && not_listed && (parent_status = "Partial Uploaded");
    listed && not_listed && uploaded && (parent_status = 'Partial Listed');

    if (product?.type !== 'simple') {
        let obj: any = getAllStatus?.[parent_status];
        if (parentProductStatus !== "") {
            obj['emptyStatus'] = false;
            obj['variant_count'] = listed_variant_count;
            obj['not_listed_count'] = Not_listed_variant_count;
        }
        else {
            obj['emptyStatus'] = true;
            obj['variant_count'] = listed_variant_count;
            obj['not_listed_count'] = Not_listed_variant_count;
        }
        return obj;
    }
    else
        return getAllStatus?.[parent_status];
}


export const calculateProductStatus = (
    statuses: (string | null)[],
    productType: string = "simple"
): any => {
    const activeStatuses = new Set(['Active', 'Inactive', 'Incomplete']);
    let parent_status = "Not Listed";
    let hasListed = false;
    let hasNotListed = false;
    let hasUploaded = false;

    let listedVariantCount = 0;
    let notListedVariantCount = 0;




    let parentProductStatus = statuses[0] ?? ""

    // Iterate through statuses and evaluate
    statuses.slice(1).forEach((status, index) => {
        if (status === 'Uploaded') {
            hasUploaded = true;
        } else if (activeStatuses.has(status ?? '')) {
            hasListed = true;
            listedVariantCount++;
        } else {
            hasNotListed = true;
            notListedVariantCount++;
        }
    });

    // Determine parent_status based on conditions
    if (hasListed && !hasNotListed) {
        parent_status = "Listed";
    } else if (!hasListed && hasNotListed) {
        parent_status = "Not Listed";
    } else if (hasListed && hasNotListed) {
        parent_status = "Partial Listed";
    }

    if (hasUploaded && !hasNotListed && !hasListed) {
        parent_status = "Uploaded";
    } else if (hasUploaded && hasListed && !hasNotListed) {
        parent_status = "Partial Listed";
    } else if (hasUploaded && hasNotListed) {
        parent_status = "Partial Uploaded";
    }


    // Wrap result into an object for parent product types
    if (productType !== "simple") {
        return {
            label: parent_status,
            emptyStatus: parentProductStatus === "",
            variant_count: listedVariantCount,
            not_listed_count: notListedVariantCount,
        };
    }

    return {
        label: parentProductStatus
    };
};


export const getAllErrors = (product: any, tartgetShopId: string) => {
    let errors: string[] = [];
    let marketPlaceDetails: any[] = product?.marketplace ?? [];
    marketPlaceDetails.forEach((ele) => (ele.target_marketplace === 'amazon' && ele.shop_id == tartgetShopId && (errors = ele?.errors ?? [])));
    return errors;
}

export const getEditedValue = (key: 'title' | 'sku' | 'price' | 'quantity' | 'status' | 'description', product: any, tartgetShopId: string) => {
    let val = '';
    let marketPlaceDetails: any[] = product?.marketplace ?? [];
    marketPlaceDetails.forEach((ele) => (
        product.source_product_id == ele.source_product_id && ele.shop_id == tartgetShopId && (val = ele?.[key] ?? '')));
    return val ? val : product[key];
}